<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="onNoClick()">{{ 'warning-message.accept' | translate }}</button>
</mat-dialog-actions>
